import { render } from "./Header.vue?vue&type=template&id=709df3f2"
import script from "./Header.vue?vue&type=script&lang=ts"
export * from "./Header.vue?vue&type=script&lang=ts"
script.render = render

export default script